export enum SchoolCandidateRemarkType {
  GeneralRemark = 1, // Unos napomene po školskom obvezniku
  CountyVerificationRemark = 2, // Tekst napomene na provjeru školskog obveznika prema županiji
}
